import { PaymentProvider } from '@/components/ds-checkout-modal/payment-context'

import NoBillingUserDialog from '@/features/SponsoredListing/modals/no-billing-user-modal'
import BuySyndicationCreditsModal from './buy-syndication-credits-modal'
import BuyTenantScreeningModal from './buy-tenant-screening-credits-modal'
import BuySponsoredListingModal from './buy-sponsored-listings-credits-modal'
import UseSyndicationCreditsModal from './use-syndication-credits-modal'
import AdvertiseYourListingModal from './advertise-your-listing-modal'
import AnalyticsReportModal from './analytics-report-modal'
import {
  SponsoredListingsDialog,
  TenantScreeningOptionsDialog,
  TenantScreeningDialog,
  SyndicationDialog,
  WarningDialog,
  AddendumsDialog
} from './ListingsDialog'

type Modals = {
  sponsoredListingDialog: boolean
  tenantScreeningOptionsDialog: boolean
  tenantScreeningDialog: boolean
  syndicationDialog: boolean
  warningDialog: boolean
  addendumsDialog: boolean
  buySyndicationCredits: boolean
  buyTenantScreening: boolean
  buySponsoredListing: boolean
  editPaymentDialog: boolean
  useSyndicationCredits: boolean
  advertiseYourListing?: boolean
  analyticsReport?: boolean
  billingUser: boolean
}

type Props = {
  visible: Modals
  closeModal: (modal: keyof Modals) => () => void
  showModal: (modal: keyof Modals) => () => void
  selectedListing: any
  handleSyndicationSubmit: any
}

const DialogWrapper = ({
  visible,
  closeModal,
  showModal,
  selectedListing,
  handleSyndicationSubmit
}: Props) => {
  return (
    <>
      <NoBillingUserDialog open={visible.billingUser} onClose={closeModal('billingUser')} />
      <SponsoredListingsDialog
        visible={visible.sponsoredListingDialog}
        closeModal={closeModal('sponsoredListingDialog')}
      />
      <TenantScreeningOptionsDialog
        showModal={showModal('tenantScreeningDialog')}
        visible={visible.tenantScreeningOptionsDialog}
        closeModal={closeModal('tenantScreeningOptionsDialog')}
      />
      <TenantScreeningDialog
        visible={visible.tenantScreeningDialog}
        closeModal={closeModal('tenantScreeningDialog')}
      />
      <SyndicationDialog
        visible={visible.syndicationDialog}
        closeModal={closeModal('syndicationDialog')}
        onSubmit={handleSyndicationSubmit}
      />
      <WarningDialog visible={visible.warningDialog} closeModal={closeModal('warningDialog')} />
      <AddendumsDialog
        visible={visible.addendumsDialog}
        closeModal={closeModal('addendumsDialog')}
      />
      <AdvertiseYourListingModal
        visible={visible.advertiseYourListing ?? false}
        closeModal={closeModal('advertiseYourListing')}
        onSubmit={showModal('syndicationDialog')}
      />
      <AnalyticsReportModal
        visible={visible.analyticsReport ?? false}
        closeModal={closeModal('analyticsReport')}
      />
      <BuySyndicationCreditsModal
        visible={visible.buySyndicationCredits}
        closeModal={closeModal('buySyndicationCredits')}
      />
      <BuyTenantScreeningModal
        visible={visible.buyTenantScreening}
        closeModal={closeModal('buyTenantScreening')}
      />
      <BuySponsoredListingModal
        visible={visible.buySponsoredListing}
        closeModal={closeModal('buySponsoredListing')}
      />
      <PaymentProvider>
        <UseSyndicationCreditsModal
          visible={visible.useSyndicationCredits}
          closeModal={closeModal('useSyndicationCredits')}
          selectedListing={selectedListing}
        />
      </PaymentProvider>
    </>
  )
}

export default DialogWrapper
